<style>
.table-dashboard thead tr td {
    background: #1f2248;
    color: #fff;
}
</style>
<template>
    <zen-one :showuserinfo="false" title="Sistem Hasil Bersepadu Kedah (iHasil)" :crumbs="crumbs">
         <z-page title="Penyesuaian Transaksi">
            <w-form ref="dform" @validate="search">
              <w-flex justify-space-between class="mb4">
                <div class="xs4">
                    <z-input 
                          label="Tarikh Proses"
                          v-model="cari.tarikh_fail"
                          type="date"/>
                </div>
                 <div class="xs4"> 
                    <w-input
                      label="Nama Fail"
                      v-model="cari.nama_fail"
                    />
                </div>
                <div class="xs4 mr5">
                  <z-lookup label="Status" name="Status" :url='service_ibayaq+"lookup/status"' :sort="false" :cache="false" v-model="cari.lkp_penyesuaian_status_id"/>
                </div>
              </w-flex>
            </w-form>

                 <div class="mt2 text-right">
                    <w-button class="ml1" v-on:click="reset()" bg-color="warning">
                        <w-icon>fal fa-redo-alt</w-icon>&nbsp;Reset
                    </w-button>
                    <w-button class="ml1" @click="$refs.dform.validate()">
                        <w-icon>fal fa-search</w-icon>&nbsp;Cari
                    </w-button>
                     <w-button  class="ml1 " @click="add()">
                        &nbsp;Muat Naik Fail Penyata
                    </w-button>
                </div>

            <w-dialog
            v-model="dialog.show"
            :fullscreen="dialog.fullscreen"
            :width="dialog.width"
            :persistent="dialog.persistent"
            :persistent-no-animation="dialog.persistentNoAnimation"
            title-class="primary-light1--bg white"
            >
            <template #title>
                <w-icon class="mr2">fal fa-user</w-icon>
                
            </template>
              <w-form ref="form" v-model="dialog.valid" @validate="hantar"  @success="onSuccess" >
                <w-flex class="mt3">
                  <z-input
                    class="xs3 mr3"
                    type="file"
                    placeholder="Sila Muatnaik Dokumen Sokongan"
                    required
                    v-model="files"
                    label="Sila Muatnaik Fail excel sahaja *" />
                  </w-flex>
                </w-form>
            

            <!-- <template #actions> -->
                <div class="spacer" />
                <!-- <template v-if="item.user_id == $page.props.auth.user.id"> -->
                  <w-button
                    class="my2 btn-zloginbox grow"
                    :loading="dialog.loading"
                    :disabled="btnStatus"
                    @click="$refs.form.validate() && !form.sent">
                    <w-icon class="mr2" xs>fal fa-sign-in-alt</w-icon> Simpan
                    </w-button>
                  <!-- </template> -->
                    &nbsp;&nbsp;
                <w-button
                    bg-color="grey-light5--bg"
                    @click="dialog.show = false"
                    >Tutup</w-button
                >
            <!-- </template> -->
            </w-dialog>
            <w-flex justify-center align-center class="mt5">
                <div class="w-card__content content-hardcode" style="overflow-x:auto;">
                    <table class="table-dashboard" width="100%">
                        <thead>
                            <tr class="center">
                                <td rowspan="2">Bil</td>
                                <td rowspan="2">Nama Fail</td>
                                <td rowspan="2">Tarikh Fail</td>
                                <!-- <td rowspan="2">Diproses Oleh</td> -->
                                <td rowspan="2">Tarikh Proses</td>
                                <td rowspan="2">Status</td>
                                <td colspan="3" class="center">Bil Rekod</td>
                                <td rowspan="2">Tindakan</td>
                            </tr>
                            <tr>
                                <td>Sepadan</td>
                                <td>Tidak Sepadan</td>
                                <td>Jumlah</td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(dt, index) in table.items">
                              <td>{{dt.no}}</td>
                              <td>{{dt.nama_fail}}</td>
                              <td>{{dt.tarikh_fail}}</td>
                              <!-- <td>{{dt.tarikh_proses}}</td> -->
                              <td>{{dt.tarikh_proses}}</td>
                              <td>{{dt.status}}</td>
                              <td>{{dt.bil_sepadan}}</td>
                              <td>{{dt.bil_ralat}}</td>
                              <td>{{dt.bil_rekod}}</td>
                              <td>
                                <w-flex class="flex justify-center">
                                    <inertia-link :href="$route('penyesuaian.recon.show', dt.id)">
                                        <w-tooltip top>
                                            <template #activator="{ on }">
                                                <w-icon v-on="on"> fal fa-file </w-icon>
                                            </template>
                                            Papar
                                        </w-tooltip>
                                    </inertia-link>
                                </w-flex>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </w-flex>
                    <w-card class="text-right">
                        <w-flex
                            v-if="table.meta.current_page"
                            class="justify-start align-center"
                        >
                            <pagination
                                class="xs11"
                                :max="table.meta.last_page"
                                :path="table.meta.path"
                                :current="table.meta.current_page"
                                :last_page="table.meta.last_page"
                                :links="table.meta.links"
                                @pageChanged="table.loadpg"
                            />
                        </w-flex>
                    </w-card>
        </z-page>
    </zen-one>
</template>

<script>
import { reactive } from 'vue'
import ZenOne from '@/Shared/ZenOne'
import ZResource from '@/Modules/z-resource-service'


export default {
  extends: ZResource,
  components: {
    // ZenOne
  },
  props: {
    items: [Array, Object],
  },
  data() {
    return {
        resourceurl: this.service_ibayaq+'penyesuaian',
        reload: true,
        btnStatus: false,
        files:[],
        crumbs: [
            // { label: this.$page.props.app_name, route: '/sitemap' },
            { label: 'iHasil', route: '/ihasil' },
        { label: 'Penyesuaian', route: '/Penyesuaian/Recon' },
        { label: 'Recon', route: '/Penyesuaian/Recon' },
          ],
        dialog: 
        {
            valid: false,
            show: false,
            fullscreen: false,
            persistent: true,
            persistentNoAnimation: false,
            loading: false,
            width: 1000,
        },
        cari: 
        {
            nama_fail: "",
            tarikh_fail: "",
            lkp_penyesuaian_status_id: "",
        },
        cari : {
          loading: false,
        },
    }
  },
  methods: {

    onSuccess () {
        setTimeout(() => (this.form.sent = true), 2000)
        this.$inertia.visit(this.$page.url)
    },
    add() {
         this.dialog.show = 1;
    },
    hantar() {
        let formData = new FormData();
        formData.append("file", this.files[0].file);
        console.log(formData);
        this.btnStatus = true;
        this.$zcomm
            .post(this.resourceurl + "/store", formData)
            .then((res) => {
                if (typeof this.onAfterAdd === "function") {
                    this.onAfterAdd();
                }
                this.$zutil.notify("Rekod telah berjaya Daftar");
            })
            .catch((err) => {})
            .finally(() => {
                // <inertia-link :href='$route("deposit.show",item.id)'>
            });
    },
    search() 
    {
    this.cari.loading = true
    this.$inertia.visit(
        window.route("penyesuaian.recon.index") +
            "?nama_fail=" +
            this.cari.nama_fail +
            "&tarikh_fail=" +
            this.cari.tarikh_fail+
            "&lkp_penyesuaian_status_id="+
            this.cari.lkp_penyesuaian_status_id,
        { preserveScroll: true }
    );
    },
    reset() 
    {
      this.cari = {
          nama_fail: "",
          tarikh_fail: "",
          lkp_penyesuaian_status_id: "",
      };
      this.search();
    },

  },
  watch: {
        files: function (val) {
            // console.log(val);
            console.log("work");
        },

  },
  mounted() {
    // override default setting
    this.dialog.width = 900
    this.cari = location.search.slice(1).split('&').map(p => p.split('=')).reduce((obj, [key, value]) => ({ ...obj, [key]: value }), {});
    if(this.cari.nama_fail){
        this.nama_fail = this.cari.nama_fail
        // this.search();
    }
    if(this.cari && this.cari.nama_fail && this.cari.nama_fail == 'undefined'){
      this.cari.nama_fail = ''
    }
    if(this.cari && this.cari.tarikh_fail && this.cari.tarikh_fail == 'undefined'){
      this.cari.tarikh_fail = ''
    }
    if(this.cari && this.cari.lkp_penyesuaian_status_id && this.cari.lkp_penyesuaian_status_id == 'undefined'){
      this.cari.lkp_penyesuaian_status_id = ''
    }
      
  },
}
</script>

<style>
.w-select__menu {
    z-index: 999999;
}

.btn-selesai {
    border-radius: 4px;
    background-color: #4CAF50; /* Green */
    border: none;
    color: white;
    padding: 4px 10px;
    text-align: center;
    text-decoration: none;
    display: inline-block;
    font-size: 12px;
    margin: 2px 1px;
    font-weight: 550;
}

.btn-baharu {
    border-radius: 4px;
    background-color: #008CBA; /* Green */
    border: none;
    color: white;
    padding: 4px 8px;
    text-align: center;
    text-decoration: none;
    display: inline-block;
    font-size: 12px;
    margin: 2px 1px;
    font-weight: 550;
}

.btn-seminggu {
    border-radius: 4px;
    background-color: #FFC300; /* Green */
    border: none;
    color: white;
    padding: 4px 8px;
    text-align: center;
    text-decoration: none;
    display: inline-block;
    font-size: 12px;
    margin: 2px 1px;
    font-weight: 550;
}

.btn-sebulan {
    border-radius: 4px;
    background-color: #C70039; /* Green */
    border: none;
    color: white;
    padding: 4px 8px;
    text-align: center;
    text-decoration: none;
    display: inline-block;
    font-size: 12px;
    margin: 2px 1px;
    font-weight: 550;
}

</style>
